module.exports = __webpack_public_path__ + "img/add-outline.906c2571.svg";